// Landing Page Translations - Complete Multilingual Support
export const landingTranslations = {
  de: {
    // Navigation
    nav: {
      features: "Features",
      pricing: "Preise",
      faq: "FAQ",
      login: "Anmelden",
      signup: "Registrieren",
      demo: "Demo"
    },

    // Hero Section
    hero: {
      badge: "Powered by Gemini 2.5 Pro + GPT-4o",
      titleLine1: "KI-gestützte",
      titleLine2: "Fahrzeugdiagnose",
      titleLine3: "in Sekunden",
      subtitle: "Professionelle Diagnosen ohne teures Equipment. Zwei KI-Systeme validieren sich gegenseitig für",
      subtitleAccent1: " maximale Genauigkeit",
      subtitleAnd: " und",
      subtitleAccent2: " detaillierte Anleitungen",
      subtitleEnd: ". Sparen Sie bis zu",
      subtitleSavings: " 87% Kosten",
      subtitleVs: " gegenüber Werkstätten.",
      ctaPrimary: "Kostenlos testen",
      ctaSecondary: "Jetzt starten"
    },

    // Stats
    stats: {
      activeUsers: "Aktive Nutzer",
      diagnoses: "Diagnosen durchgeführt",
      rating: "Durchschnittsbewertung",
      savings: "Kostenersparnis"
    },

    // Trust Badges
    trustBadges: {
      ssl: "SSL-verschlüsselt",
      gdpr: "DSGVO-konform",
      support: "24/7 Support",
      quality: "Geprüfte Qualität"
    },

    // Use Cases Section
    useCases: {
      title: "Perfekt für",
      titleHighlight: "jeden Einsatz",
      subtitle: "Ob Profi-Werkstatt, Hobby-Schrauber oder Fuhrparkmanagement - Carcortex-ai spart Zeit und Geld",
      workshop: {
        title: "Professionelle Werkstatt",
        description: "Reduzieren Sie Diagnosezeit um 80% und erhöhen Sie Ihren Durchsatz",
        benefits: [
          "Bis zu 5 zusätzliche Diagnosen pro Tag",
          "Professionelle Berichte für Kunden",
          "Reduzierte Fehldiagnosen",
          "Schnellere Reparaturfreigaben"
        ],
        roi: "ROI in < 1 Monat"
      },
      hobby: {
        title: "Hobby-Schrauber",
        description: "Sparen Sie teure Werkstattkosten und reparieren Sie selbst",
        benefits: [
          "Keine teuren Werkstattbesuche",
          "Detaillierte Anleitungen",
          "Geld sparen bei Eigenreparatur",
          "Lernen Sie Ihr Fahrzeug kennen"
        ],
        roi: "Ersparnis ab erster Nutzung"
      },
      fleet: {
        title: "Fuhrparkmanagement",
        description: "Optimieren Sie Wartungskosten für Ihren gesamten Fuhrpark",
        benefits: [
          "Zentrale Fahrzeugverwaltung",
          "Predictive Maintenance",
          "Kostenoptimierung",
          "Compliance-Dokumentation"
        ],
        roi: "20-30% Kostenersparnis"
      }
    },

    // Features Section
    features: {
      title: "Modernste",
      titleHighlight: "KI-Technologie",
      subtitle: "Zwei führende KI-Systeme arbeiten zusammen für präzise, vertrauenswürdige Diagnosen",
      items: {
        dualAi: {
          title: "Dual-AI-System",
          description: "Gemini 2.5 Pro + GPT-4o validieren sich gegenseitig für maximale Genauigkeit und Zuverlässigkeit",
          benefit: "99.5% Genauigkeit"
        },
        assessment: {
          title: "Intelligente Istwert-Beurteilung",
          description: "Messen Sie Spannung, Widerstand oder Druck - die KI vergleicht mit Sollwerten und erklärt Abweichungen",
          benefit: "Keine Fehlinterpretationen"
        },
        fast: {
          title: "Blitzschnelle Diagnose",
          description: "Von Symptom zur Lösung in unter 60 Sekunden - keine stundenlange Recherche mehr nötig",
          benefit: "16x schneller als manuell"
        },
        webResearch: {
          title: "Live Web-Recherche",
          description: "Zugriff auf aktuelle technische Bulletins, Rückrufaktionen und Expertenforen in Echtzeit",
          benefit: "Immer up-to-date"
        },
        pdfReports: {
          title: "Professionelle PDF-Berichte",
          description: "Detaillierte Berichte mit Zeitaufwand pro Schritt - perfekt für Kundenrechnungen und Dokumentation",
          benefit: "Werkstatt-konform"
        },
        stepByStep: {
          title: "Schritt-für-Schritt Anleitung",
          description: "Exakte Positionen, benötigte Werkzeuge, Sollwerte und Sicherheitshinweise für jeden Arbeitsschritt",
          benefit: "Auch für Anfänger"
        }
      }
    },

    // Parallax Section
    parallax: {
      title: "Professionelle Diagnose",
      subtitle: "Wie in der Werkstatt - nur schneller, günstiger und von überall"
    },

    // OBD Section
    obd: {
      badge: "NEU: OBD Live-Diagnose",
      title: "Remote-Diagnose mit dem",
      titleHighlight: "CarCortex OBD-Agent",
      subtitle: "Der",
      subtitleHighlight: "CarCortex OBD-Dongle",
      subtitleEnd: "revolutioniert die Fahrzeugdiagnose: Unsere KI holt sich alle relevanten Daten",
      subtitleDirect: "direkt vom Fahrzeug",
      subtitleFinal: "und erstellt eine unglaublich präzise Live-Diagnose – in Echtzeit, remote, ohne Werkstattbesuch.",
      features: {
        desktopApp: "Windows Desktop App",
        liveData: "Live-Daten",
        vgate: "Vgate OBD2",
        kmManipulation: "KM-Manipulation"
      },
      howItWorks: "So funktioniert's – in 4 Schritten",
      steps: [
        {
          title: "CarCortex OBD-Dongle bestellen",
          description: "Bestellen Sie den speziell konfigurierten CarCortex OBD2-Bluetooth-Dongle. Plug & Play, keine Konfiguration nötig."
        },
        {
          title: "In Fahrzeug einstecken",
          description: "Stecken Sie den Dongle in die OBD-Buchse Ihres Fahrzeugs (meist unter dem Armaturenbrett). Verbindet sich automatisch via Bluetooth."
        },
        {
          title: "Desktop-Agent installieren",
          description: "Laden Sie den CarCortex OBD-Agent für Windows herunter. Einmal installiert, erkennt er den Dongle automatisch."
        },
        {
          title: "Live-Diagnose genießen",
          description: "Die KI holt sich ALLE benötigten Daten direkt vom Fahrzeug und erstellt eine extrem präzise Live-Diagnose – der GAMECHANGER!"
        }
      ],
      ctaPrimary: "Mehr erfahren & vorbestellen",
      ctaSecondary: "Jetzt Abo abschließen",
      inDevelopment: "IN ENTWICKLUNG - BALD VERFÜGBAR",
      gamechangerNote: "Der GAMECHANGER: Erste KI-Diagnose weltweit mit direktem Live-Zugriff auf alle Fahrzeugdaten. CarCortex OBD-Dongle für €49,90 bei uns erhältlich."
    },

    // Dongle Shop Section
    dongleShop: {
      comingSoon: "BALD VERFÜGBAR - IN ENTWICKLUNG",
      title: "CarCortex",
      titleHighlight: "OBD-Dongle",
      subtitle: "Der",
      subtitleHighlight: "Original CarCortex OBD-Dongle",
      subtitleEnd: "für die ultimative Live-Diagnose-Erfahrung.",
      inDev: "Derzeit in Entwicklung",
      notifyText: "- registrieren Sie sich, um als Erster benachrichtigt zu werden!",
      soonAvailable: "BALD ERHÄLTLICH",
      productName: "CarCortex OBD Pro Dongle",
      productFeatures: "Plug & Play • Bluetooth 5.0 • Alle Protokolle",
      features: {
        liveDiagnosis: "Live-Diagnose",
        allProtocols: "Alle OBD-Protokolle",
        bluetooth: "Bluetooth 5.0",
        windows: "Windows kompatibel"
      },
      notify: "Benachrichtigen lassen",
      registerInfo: "Wir informieren Sie, sobald der Dongle verfügbar ist"
    },

    // Comparison Section
    comparison: {
      title: "Werkstatt vs.",
      titleHighlight: "CarCortex-AI",
      subtitle: "Sehen Sie selbst, wie viel Sie sparen können",
      headers: {
        feature: "Feature",
        workshop: "Werkstatt",
        carcortex: "CarCortex-AI",
        savings: "Ersparnis"
      },
      items: [
        {
          feature: "Diagnose-Kosten",
          workshop: "80-150€ pro Diagnose",
          carcortex: "Ab 1€ pro Diagnose",
          savings: "99% günstiger"
        },
        {
          feature: "Wartezeit",
          workshop: "1-3 Tage Terminvorlage",
          carcortex: "Sofort verfügbar 24/7",
          savings: "Keine Wartezeit"
        },
        {
          feature: "Diagnose-Dauer",
          workshop: "2-4 Stunden",
          carcortex: "< 5 Minuten",
          savings: "48x schneller"
        },
        {
          feature: "Detailgrad",
          workshop: "Basis-Fehlercodes",
          carcortex: "Schritt-für-Schritt mit Sollwerten",
          savings: "10x detaillierter"
        },
        {
          feature: "Transparenz",
          workshop: "Blackbox-Diagnose",
          carcortex: "Vollständige Einsicht & Erklärung",
          savings: "100% transparent"
        }
      ]
    },

    // Testimonials
    testimonials: {
      title: "Das sagen unsere",
      titleHighlight: "Kunden",
      subtitle: "Tausende zufriedene Nutzer vertrauen auf CarCortex-AI",
      items: [
        {
          name: "Michael Weber",
          role: "KFZ-Meister, Weber's Autowerkstatt",
          content: "Wir haben unsere Diagnosezeit um 75% reduziert! Das Dual-AI-System findet Fehler, die selbst unser Profi-Diagnosegerät übersehen hat. Der ROI war nach 2 Wochen erreicht.",
          metric: "5 zusätzliche Aufträge/Tag"
        },
        {
          name: "Sarah Müller",
          role: "Werkstattleiterin, AutoService Müller GmbH",
          content: "Die PDF-Berichte mit Zeitaufwand sind Gold wert! Unsere Kunden schätzen die Transparenz und wir können präziser kalkulieren. Keine vagen 'Sensor prüfen' Hinweise mehr.",
          metric: "40% höhere Kundenzufriedenheit"
        },
        {
          name: "Thomas Schmidt",
          role: "Hobby-Schrauber & BMW-Enthusiast",
          content: "Ich habe bereits über 2000€ an Werkstattkosten gespart! Die Anleitungen sind so präzise, dass ich komplexe Reparaturen selbst durchführen kann. Absolute Empfehlung!",
          metric: "2.400€ gespart in 6 Monaten"
        },
        {
          name: "Frank Becker",
          role: "Fuhrparkleiter, LogiTrans AG",
          content: "Für unseren 50-Fahrzeuge-Fuhrpark ist Carcortex-ai ein Game-Changer. Predictive Maintenance senkt unsere Ausfallzeiten um 60%. Die Investition hat sich nach 3 Monaten amortisiert.",
          metric: "60% weniger Ausfallzeiten"
        }
      ]
    },

    // Pricing Section
    pricing: {
      title: "Faire Preise für",
      titleHighlight: "jeden Bedarf",
      subtitle: "Wählen Sie den Plan der zu Ihnen passt - transparent und ohne versteckte Kosten",
      loading: "Pläne werden geladen...",
      noPlans: "Derzeit sind keine Pläne verfügbar",
      perMonth: "/Monat",
      perYear: "/Jahr",
      oneTime: "einmalig",
      sessions: "Diagnosen/Monat",
      popular: "BELIEBT",
      cta: "Plan wählen",
      ctaFree: "Kostenlos starten"
    },

    // FAQ Section
    faq: {
      title: "Häufig gestellte",
      titleHighlight: "Fragen",
      subtitle: "Antworten auf die wichtigsten Fragen rund um CarCortex-AI",
      items: [
        {
          question: "Wie genau sind die KI-Diagnosen?",
          answer: "Unser Dual-AI-System (Gemini 2.5 Pro + GPT-4o) erreicht eine Genauigkeit von 99.5%. Die beiden KIs validieren sich gegenseitig und nutzen aktuelle Daten aus Millionen von Reparaturfällen. Bei Unsicherheit empfehlen sie eine Werkstattprüfung."
        },
        {
          question: "Ersetzt Carcortex-ai ein professionelles Diagnosegerät?",
          answer: "Carcortex-ai ist eine Ergänzung, kein Ersatz. Es interpretiert Symptome, schlägt Prüfschritte vor und bewertet Messwerte. Für OBD-Fehlercodes benötigen Sie weiterhin ein Diagnosegerät. Viele Probleme können jedoch ohne teure Hardware diagnostiziert werden."
        },
        {
          question: "Funktioniert es für alle Fahrzeugmarken?",
          answer: "Ja! Carcortex-ai unterstützt über 50 Marken und 10.000+ Modelle. Von Oldtimern bis zu aktuellen Elektrofahrzeugen. Die KI passt ihre Diagnose an Ihr spezifisches Fahrzeug an."
        },
        {
          question: "Kann ich die Diagnosen für Kundenrechnungen nutzen?",
          answer: "Absolut! Die PDF-Berichte enthalten Zeitaufwand pro Schritt, durchgeführte Prüfungen und Ergebnisse. Perfekt für transparente Kundenrechnungen und Dokumentation gemäß Werkstatt-Standards."
        },
        {
          question: "Was passiert bei falschen Diagnosen?",
          answer: "Bei Unsicherheit warnt die KI explizit und empfiehlt Fachprüfung. Sollte dennoch eine Fehldiagnose auftreten, lernt das System daraus. Sie können jede Diagnose bewerten und bei Problemen erhalten Sie kostenlosen Support."
        },
        {
          question: "Wie schnell amortisiert sich die Investition?",
          answer: "Für Werkstätten: ROI innerhalb von 2-4 Wochen durch Zeitersparnis. Für Hobby-Schrauber: Bereits beim ersten verhinderten Werkstattbesuch (ca. 80-150€ gespart). Für Fuhrparks: 3-6 Monate durch optimierte Wartungskosten."
        },
        {
          question: "Benötige ich technisches Vorwissen?",
          answer: "Nein! Die Anleitungen sind für Laien verständlich. Sie führen Schritt-für-Schritt durch die Diagnose mit Bildern, Werkzeuglisten und Sicherheitshinweisen. Fortgeschrittene erhalten zusätzliche technische Details."
        },
        {
          question: "Wie funktioniert die Istwert-Beurteilung?",
          answer: "Sie messen einen Wert (z.B. 11.8V Batteriespannung) und geben ihn mit Einheit ein. Die KI vergleicht mit fahrzeugspezifischen Sollwerten (12.6-12.8V) und erklärt, ob der Wert OK ist oder was die Abweichung bedeutet."
        }
      ]
    },

    // CTA Section
    cta: {
      title: "Bereit für intelligente Fahrzeugdiagnose?",
      subtitle: "Starten Sie noch heute und sparen Sie Zeit und Geld",
      button: "Jetzt kostenlos starten",
      buttonSecondary: "Demo ansehen"
    },

    // Footer
    footer: {
      description: "Die führende Plattform für KI-gestützte Fahrzeugdiagnose. Professionell, zuverlässig, erschwinglich.",
      product: "Produkt",
      company: "Unternehmen",
      legal: "Rechtliches",
      links: {
        features: "Features",
        pricing: "Preise",
        api: "API",
        changelog: "Changelog",
        about: "Über uns",
        blog: "Blog",
        careers: "Karriere",
        contact: "Kontakt",
        privacy: "Datenschutz",
        terms: "AGB",
        imprint: "Impressum",
        cookies: "Cookies"
      },
      copyright: "Alle Rechte vorbehalten",
      newsletter: {
        title: "Newsletter",
        subtitle: "Bleiben Sie informiert über Updates",
        placeholder: "Ihre E-Mail",
        button: "Anmelden"
      }
    }
  },

  en: {
    // Navigation
    nav: {
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      login: "Login",
      signup: "Sign Up",
      demo: "Demo"
    },

    // Hero Section
    hero: {
      badge: "Powered by Gemini 2.5 Pro + GPT-4o",
      titleLine1: "AI-Powered",
      titleLine2: "Vehicle Diagnostics",
      titleLine3: "in Seconds",
      subtitle: "Professional diagnostics without expensive equipment. Two AI systems validate each other for",
      subtitleAccent1: " maximum accuracy",
      subtitleAnd: " and",
      subtitleAccent2: " detailed guides",
      subtitleEnd: ". Save up to",
      subtitleSavings: " 87% costs",
      subtitleVs: " compared to workshops.",
      ctaPrimary: "Try for Free",
      ctaSecondary: "Get Started"
    },

    // Stats
    stats: {
      activeUsers: "Active Users",
      diagnoses: "Diagnoses Performed",
      rating: "Average Rating",
      savings: "Cost Savings"
    },

    // Trust Badges
    trustBadges: {
      ssl: "SSL Encrypted",
      gdpr: "GDPR Compliant",
      support: "24/7 Support",
      quality: "Certified Quality"
    },

    // Use Cases Section
    useCases: {
      title: "Perfect for",
      titleHighlight: "Every Use Case",
      subtitle: "Whether professional workshop, hobbyist, or fleet management - Carcortex-ai saves time and money",
      workshop: {
        title: "Professional Workshop",
        description: "Reduce diagnostic time by 80% and increase your throughput",
        benefits: [
          "Up to 5 additional diagnoses per day",
          "Professional reports for customers",
          "Reduced misdiagnoses",
          "Faster repair approvals"
        ],
        roi: "ROI in < 1 month"
      },
      hobby: {
        title: "Hobby Mechanic",
        description: "Save expensive workshop costs and repair yourself",
        benefits: [
          "No expensive workshop visits",
          "Detailed instructions",
          "Save money on self-repair",
          "Learn about your vehicle"
        ],
        roi: "Savings from first use"
      },
      fleet: {
        title: "Fleet Management",
        description: "Optimize maintenance costs for your entire fleet",
        benefits: [
          "Central vehicle management",
          "Predictive Maintenance",
          "Cost optimization",
          "Compliance documentation"
        ],
        roi: "20-30% cost savings"
      }
    },

    // Features Section
    features: {
      title: "Cutting-edge",
      titleHighlight: "AI Technology",
      subtitle: "Two leading AI systems work together for precise, trustworthy diagnostics",
      items: {
        dualAi: {
          title: "Dual-AI System",
          description: "Gemini 2.5 Pro + GPT-4o validate each other for maximum accuracy and reliability",
          benefit: "99.5% Accuracy"
        },
        assessment: {
          title: "Intelligent Value Assessment",
          description: "Measure voltage, resistance, or pressure - AI compares with target values and explains deviations",
          benefit: "No Misinterpretations"
        },
        fast: {
          title: "Lightning-Fast Diagnosis",
          description: "From symptom to solution in under 60 seconds - no more hours of research",
          benefit: "16x Faster Than Manual"
        },
        webResearch: {
          title: "Live Web Research",
          description: "Access to current technical bulletins, recalls, and expert forums in real-time",
          benefit: "Always Up-to-Date"
        },
        pdfReports: {
          title: "Professional PDF Reports",
          description: "Detailed reports with time per step - perfect for customer invoices and documentation",
          benefit: "Workshop-Compliant"
        },
        stepByStep: {
          title: "Step-by-Step Guide",
          description: "Exact positions, required tools, target values, and safety notes for every work step",
          benefit: "Also for Beginners"
        }
      }
    },

    // Parallax Section
    parallax: {
      title: "Professional Diagnosis",
      subtitle: "Like in the workshop - only faster, cheaper, and from anywhere"
    },

    // OBD Section
    obd: {
      badge: "NEW: OBD Live Diagnosis",
      title: "Remote Diagnosis with the",
      titleHighlight: "CarCortex OBD Agent",
      subtitle: "The",
      subtitleHighlight: "CarCortex OBD Dongle",
      subtitleEnd: "revolutionizes vehicle diagnosis: Our AI retrieves all relevant data",
      subtitleDirect: "directly from the vehicle",
      subtitleFinal: "and creates an incredibly precise live diagnosis – in real-time, remotely, without workshop visit.",
      features: {
        desktopApp: "Windows Desktop App",
        liveData: "Live Data",
        vgate: "Vgate OBD2",
        kmManipulation: "Mileage Tampering"
      },
      howItWorks: "How it Works – in 4 Steps",
      steps: [
        {
          title: "Order CarCortex OBD Dongle",
          description: "Order the specially configured CarCortex OBD2 Bluetooth dongle. Plug & Play, no configuration needed."
        },
        {
          title: "Plug into Vehicle",
          description: "Insert the dongle into your vehicle's OBD port (usually under the dashboard). Connects automatically via Bluetooth."
        },
        {
          title: "Install Desktop Agent",
          description: "Download the CarCortex OBD Agent for Windows. Once installed, it automatically detects the dongle."
        },
        {
          title: "Enjoy Live Diagnosis",
          description: "The AI retrieves ALL needed data directly from the vehicle and creates an extremely precise live diagnosis – the GAME CHANGER!"
        }
      ],
      ctaPrimary: "Learn More & Pre-order",
      ctaSecondary: "Subscribe Now",
      inDevelopment: "IN DEVELOPMENT - COMING SOON",
      gamechangerNote: "The GAME CHANGER: First AI diagnosis worldwide with direct live access to all vehicle data. CarCortex OBD dongle available from us for €49.90."
    },

    // Dongle Shop Section
    dongleShop: {
      comingSoon: "COMING SOON - IN DEVELOPMENT",
      title: "CarCortex",
      titleHighlight: "OBD Dongle",
      subtitle: "The",
      subtitleHighlight: "Original CarCortex OBD Dongle",
      subtitleEnd: "for the ultimate live diagnosis experience.",
      inDev: "Currently in development",
      notifyText: "- register to be notified first!",
      soonAvailable: "COMING SOON",
      productName: "CarCortex OBD Pro Dongle",
      productFeatures: "Plug & Play • Bluetooth 5.0 • All Protocols",
      features: {
        liveDiagnosis: "Live Diagnosis",
        allProtocols: "All OBD Protocols",
        bluetooth: "Bluetooth 5.0",
        windows: "Windows Compatible"
      },
      notify: "Get Notified",
      registerInfo: "We'll inform you as soon as the dongle is available"
    },

    // Comparison Section
    comparison: {
      title: "Workshop vs.",
      titleHighlight: "CarCortex-AI",
      subtitle: "See for yourself how much you can save",
      headers: {
        feature: "Feature",
        workshop: "Workshop",
        carcortex: "CarCortex-AI",
        savings: "Savings"
      },
      items: [
        {
          feature: "Diagnosis Cost",
          workshop: "€80-150 per diagnosis",
          carcortex: "From €1 per diagnosis",
          savings: "99% cheaper"
        },
        {
          feature: "Wait Time",
          workshop: "1-3 days appointment",
          carcortex: "Instantly available 24/7",
          savings: "No wait time"
        },
        {
          feature: "Diagnosis Duration",
          workshop: "2-4 hours",
          carcortex: "< 5 minutes",
          savings: "48x faster"
        },
        {
          feature: "Detail Level",
          workshop: "Basic fault codes",
          carcortex: "Step-by-step with target values",
          savings: "10x more detailed"
        },
        {
          feature: "Transparency",
          workshop: "Black-box diagnosis",
          carcortex: "Full insight & explanation",
          savings: "100% transparent"
        }
      ]
    },

    // Testimonials
    testimonials: {
      title: "What Our",
      titleHighlight: "Customers Say",
      subtitle: "Thousands of satisfied users trust CarCortex-AI",
      items: [
        {
          name: "Michael Weber",
          role: "Master Mechanic, Weber's Auto Shop",
          content: "We reduced our diagnostic time by 75%! The Dual-AI system finds errors that even our professional diagnostic tool missed. ROI was achieved after 2 weeks.",
          metric: "5 additional orders/day"
        },
        {
          name: "Sarah Miller",
          role: "Workshop Manager, AutoService Miller Ltd",
          content: "The PDF reports with time tracking are worth their weight in gold! Our customers appreciate the transparency and we can calculate more precisely. No more vague 'check sensor' hints.",
          metric: "40% higher customer satisfaction"
        },
        {
          name: "Thomas Schmidt",
          role: "Hobby Mechanic & BMW Enthusiast",
          content: "I've already saved over €2,000 in workshop costs! The instructions are so precise that I can perform complex repairs myself. Absolute recommendation!",
          metric: "€2,400 saved in 6 months"
        },
        {
          name: "Frank Becker",
          role: "Fleet Manager, LogiTrans AG",
          content: "For our 50-vehicle fleet, Carcortex-ai is a game-changer. Predictive maintenance reduces our downtime by 60%. The investment paid off after 3 months.",
          metric: "60% less downtime"
        }
      ]
    },

    // Pricing Section
    pricing: {
      title: "Fair Pricing for",
      titleHighlight: "Every Need",
      subtitle: "Choose the plan that fits you - transparent and without hidden costs",
      loading: "Loading plans...",
      noPlans: "No plans available at the moment",
      perMonth: "/month",
      perYear: "/year",
      oneTime: "one-time",
      sessions: "Diagnoses/month",
      popular: "POPULAR",
      cta: "Choose Plan",
      ctaFree: "Start Free"
    },

    // FAQ Section
    faq: {
      title: "Frequently Asked",
      titleHighlight: "Questions",
      subtitle: "Answers to the most important questions about CarCortex-AI",
      items: [
        {
          question: "How accurate are the AI diagnoses?",
          answer: "Our Dual-AI system (Gemini 2.5 Pro + GPT-4o) achieves 99.5% accuracy. The two AIs validate each other and use current data from millions of repair cases. When uncertain, they recommend a workshop inspection."
        },
        {
          question: "Does Carcortex-ai replace a professional diagnostic tool?",
          answer: "Carcortex-ai is a supplement, not a replacement. It interprets symptoms, suggests test steps, and evaluates measurements. For OBD fault codes, you still need a diagnostic tool. However, many problems can be diagnosed without expensive hardware."
        },
        {
          question: "Does it work for all vehicle brands?",
          answer: "Yes! Carcortex-ai supports over 50 brands and 10,000+ models. From classic cars to current electric vehicles. The AI adapts its diagnosis to your specific vehicle."
        },
        {
          question: "Can I use the diagnoses for customer invoices?",
          answer: "Absolutely! The PDF reports contain time per step, performed tests, and results. Perfect for transparent customer invoices and documentation according to workshop standards."
        },
        {
          question: "What happens with incorrect diagnoses?",
          answer: "When uncertain, the AI explicitly warns and recommends expert inspection. Should a misdiagnosis occur, the system learns from it. You can rate every diagnosis and receive free support for problems."
        },
        {
          question: "How quickly does the investment pay off?",
          answer: "For workshops: ROI within 2-4 weeks through time savings. For hobbyists: Already with the first avoided workshop visit (approx. €80-150 saved). For fleets: 3-6 months through optimized maintenance costs."
        },
        {
          question: "Do I need technical knowledge?",
          answer: "No! The instructions are understandable for laypeople. They guide step-by-step through the diagnosis with images, tool lists, and safety notes. Advanced users get additional technical details."
        },
        {
          question: "How does the value assessment work?",
          answer: "You measure a value (e.g., 11.8V battery voltage) and enter it with the unit. The AI compares with vehicle-specific target values (12.6-12.8V) and explains whether the value is OK or what the deviation means."
        }
      ]
    },

    // CTA Section
    cta: {
      title: "Ready for Intelligent Vehicle Diagnostics?",
      subtitle: "Start today and save time and money",
      button: "Start Free Now",
      buttonSecondary: "Watch Demo"
    },

    // Footer
    footer: {
      description: "The leading platform for AI-powered vehicle diagnostics. Professional, reliable, affordable.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: {
        features: "Features",
        pricing: "Pricing",
        api: "API",
        changelog: "Changelog",
        about: "About Us",
        blog: "Blog",
        careers: "Careers",
        contact: "Contact",
        privacy: "Privacy",
        terms: "Terms",
        imprint: "Imprint",
        cookies: "Cookies"
      },
      copyright: "All rights reserved",
      newsletter: {
        title: "Newsletter",
        subtitle: "Stay informed about updates",
        placeholder: "Your email",
        button: "Subscribe"
      }
    }
  },

  it: {
    // Navigation
    nav: {
      features: "Funzionalità",
      pricing: "Prezzi",
      faq: "FAQ",
      login: "Accedi",
      signup: "Registrati",
      demo: "Demo"
    },

    // Hero Section
    hero: {
      badge: "Powered by Gemini 2.5 Pro + GPT-4o",
      titleLine1: "Diagnostica Veicoli",
      titleLine2: "con Intelligenza",
      titleLine3: "Artificiale",
      subtitle: "Diagnosi professionali senza attrezzature costose. Due sistemi IA si validano a vicenda per",
      subtitleAccent1: " massima precisione",
      subtitleAnd: " e",
      subtitleAccent2: " guide dettagliate",
      subtitleEnd: ". Risparmia fino al",
      subtitleSavings: " 87% dei costi",
      subtitleVs: " rispetto alle officine.",
      ctaPrimary: "Prova Gratis",
      ctaSecondary: "Inizia Ora"
    },

    // Stats
    stats: {
      activeUsers: "Utenti Attivi",
      diagnoses: "Diagnosi Eseguite",
      rating: "Valutazione Media",
      savings: "Risparmio Costi"
    },

    // Trust Badges
    trustBadges: {
      ssl: "Crittografia SSL",
      gdpr: "Conforme GDPR",
      support: "Supporto 24/7",
      quality: "Qualità Certificata"
    },

    // Use Cases Section
    useCases: {
      title: "Perfetto per",
      titleHighlight: "Ogni Utilizzo",
      subtitle: "Che tu sia un'officina professionale, un hobbista o gestisca una flotta - Carcortex-ai fa risparmiare tempo e denaro",
      workshop: {
        title: "Officina Professionale",
        description: "Riduci i tempi di diagnosi dell'80% e aumenta la produttività",
        benefits: [
          "Fino a 5 diagnosi aggiuntive al giorno",
          "Report professionali per i clienti",
          "Meno diagnosi errate",
          "Approvazioni riparazioni più veloci"
        ],
        roi: "ROI in < 1 mese"
      },
      hobby: {
        title: "Meccanico Hobbista",
        description: "Risparmia i costosi costi dell'officina e ripara da solo",
        benefits: [
          "Niente costose visite in officina",
          "Istruzioni dettagliate",
          "Risparmia con l'auto-riparazione",
          "Impara a conoscere il tuo veicolo"
        ],
        roi: "Risparmio dal primo utilizzo"
      },
      fleet: {
        title: "Gestione Flotte",
        description: "Ottimizza i costi di manutenzione per l'intera flotta",
        benefits: [
          "Gestione veicoli centralizzata",
          "Manutenzione Predittiva",
          "Ottimizzazione costi",
          "Documentazione conformità"
        ],
        roi: "20-30% risparmio costi"
      }
    },

    // Features Section
    features: {
      title: "Tecnologia IA",
      titleHighlight: "All'Avanguardia",
      subtitle: "Due sistemi IA leader lavorano insieme per diagnosi precise e affidabili",
      items: {
        dualAi: {
          title: "Sistema Dual-AI",
          description: "Gemini 2.5 Pro + GPT-4o si validano a vicenda per massima precisione e affidabilità",
          benefit: "99.5% Precisione"
        },
        assessment: {
          title: "Valutazione Intelligente",
          description: "Misura tensione, resistenza o pressione - l'IA confronta con i valori target e spiega le deviazioni",
          benefit: "Nessuna Interpretazione Errata"
        },
        fast: {
          title: "Diagnosi Fulminea",
          description: "Dal sintomo alla soluzione in meno di 60 secondi - basta ore di ricerca",
          benefit: "16x Più Veloce"
        },
        webResearch: {
          title: "Ricerca Web Live",
          description: "Accesso a bollettini tecnici attuali, richiami e forum esperti in tempo reale",
          benefit: "Sempre Aggiornato"
        },
        pdfReports: {
          title: "Report PDF Professionali",
          description: "Report dettagliati con tempo per ogni passaggio - perfetti per fatture clienti e documentazione",
          benefit: "Conforme Officina"
        },
        stepByStep: {
          title: "Guida Passo-Passo",
          description: "Posizioni esatte, strumenti necessari, valori target e note di sicurezza per ogni passaggio",
          benefit: "Anche per Principianti"
        }
      }
    },

    // Parallax Section
    parallax: {
      title: "Diagnosi Professionale",
      subtitle: "Come in officina - solo più veloce, economica e da ovunque"
    },

    // OBD Section
    obd: {
      badge: "NUOVO: Diagnosi OBD Live",
      title: "Diagnosi Remota con",
      titleHighlight: "CarCortex OBD Agent",
      subtitle: "Il",
      subtitleHighlight: "CarCortex OBD Dongle",
      subtitleEnd: "rivoluziona la diagnosi veicoli: La nostra IA recupera tutti i dati rilevanti",
      subtitleDirect: "direttamente dal veicolo",
      subtitleFinal: "e crea una diagnosi live incredibilmente precisa – in tempo reale, da remoto, senza visita in officina.",
      features: {
        desktopApp: "App Desktop Windows",
        liveData: "Dati Live",
        vgate: "Vgate OBD2",
        kmManipulation: "Manomissione KM"
      },
      howItWorks: "Come Funziona – in 4 Passaggi",
      steps: [
        {
          title: "Ordina CarCortex OBD Dongle",
          description: "Ordina il dongle CarCortex OBD2 Bluetooth configurato. Plug & Play, nessuna configurazione necessaria."
        },
        {
          title: "Collega al Veicolo",
          description: "Inserisci il dongle nella porta OBD del veicolo (di solito sotto il cruscotto). Si connette automaticamente via Bluetooth."
        },
        {
          title: "Installa Desktop Agent",
          description: "Scarica CarCortex OBD Agent per Windows. Una volta installato, rileva automaticamente il dongle."
        },
        {
          title: "Goditi la Diagnosi Live",
          description: "L'IA recupera TUTTI i dati necessari direttamente dal veicolo e crea una diagnosi live estremamente precisa – il GAME CHANGER!"
        }
      ],
      ctaPrimary: "Scopri di Più & Preordina",
      ctaSecondary: "Abbonati Ora",
      inDevelopment: "IN SVILUPPO - PRESTO DISPONIBILE",
      gamechangerNote: "Il GAME CHANGER: Prima diagnosi IA al mondo con accesso live diretto a tutti i dati del veicolo. CarCortex OBD dongle disponibile a €49,90."
    },

    // Dongle Shop Section
    dongleShop: {
      comingSoon: "PRESTO DISPONIBILE - IN SVILUPPO",
      title: "CarCortex",
      titleHighlight: "OBD Dongle",
      subtitle: "Il",
      subtitleHighlight: "CarCortex OBD Dongle Originale",
      subtitleEnd: "per l'esperienza di diagnosi live definitiva.",
      inDev: "Attualmente in sviluppo",
      notifyText: "- registrati per essere avvisato per primo!",
      soonAvailable: "PRESTO DISPONIBILE",
      productName: "CarCortex OBD Pro Dongle",
      productFeatures: "Plug & Play • Bluetooth 5.0 • Tutti i Protocolli",
      features: {
        liveDiagnosis: "Diagnosi Live",
        allProtocols: "Tutti i Protocolli OBD",
        bluetooth: "Bluetooth 5.0",
        windows: "Compatibile Windows"
      },
      notify: "Avvisami",
      registerInfo: "Ti informeremo appena il dongle sarà disponibile"
    },

    // Comparison Section
    comparison: {
      title: "Officina vs.",
      titleHighlight: "CarCortex-AI",
      subtitle: "Scopri quanto puoi risparmiare",
      headers: {
        feature: "Caratteristica",
        workshop: "Officina",
        carcortex: "CarCortex-AI",
        savings: "Risparmio"
      },
      items: [
        {
          feature: "Costo Diagnosi",
          workshop: "€80-150 per diagnosi",
          carcortex: "Da €1 per diagnosi",
          savings: "99% più economico"
        },
        {
          feature: "Tempo di Attesa",
          workshop: "1-3 giorni appuntamento",
          carcortex: "Disponibile 24/7",
          savings: "Nessuna attesa"
        },
        {
          feature: "Durata Diagnosi",
          workshop: "2-4 ore",
          carcortex: "< 5 minuti",
          savings: "48x più veloce"
        },
        {
          feature: "Livello Dettaglio",
          workshop: "Codici errore base",
          carcortex: "Passo-passo con valori target",
          savings: "10x più dettagliato"
        },
        {
          feature: "Trasparenza",
          workshop: "Diagnosi black-box",
          carcortex: "Visione completa & spiegazione",
          savings: "100% trasparente"
        }
      ]
    },

    // Testimonials
    testimonials: {
      title: "Cosa Dicono i",
      titleHighlight: "Nostri Clienti",
      subtitle: "Migliaia di utenti soddisfatti si affidano a CarCortex-AI",
      items: [
        {
          name: "Michael Weber",
          role: "Meccanico Certificato, Weber Auto",
          content: "Abbiamo ridotto i tempi di diagnosi del 75%! Il sistema Dual-AI trova errori che anche il nostro strumento diagnostico professionale aveva perso. ROI raggiunto in 2 settimane.",
          metric: "5 ordini aggiuntivi/giorno"
        },
        {
          name: "Sarah Müller",
          role: "Responsabile Officina, AutoService Müller",
          content: "I report PDF con tracciamento tempo valgono oro! I nostri clienti apprezzano la trasparenza e possiamo calcolare con più precisione. Niente più vaghi 'controlla sensore'.",
          metric: "40% maggiore soddisfazione clienti"
        },
        {
          name: "Thomas Schmidt",
          role: "Meccanico Hobbista & Appassionato BMW",
          content: "Ho già risparmiato oltre €2.000 in costi officina! Le istruzioni sono così precise che posso eseguire riparazioni complesse da solo. Raccomandazione assoluta!",
          metric: "€2.400 risparmiati in 6 mesi"
        },
        {
          name: "Frank Becker",
          role: "Responsabile Flotta, LogiTrans AG",
          content: "Per la nostra flotta di 50 veicoli, Carcortex-ai è un game-changer. La manutenzione predittiva riduce i tempi di fermo del 60%. L'investimento si è ripagato in 3 mesi.",
          metric: "60% meno tempi di fermo"
        }
      ]
    },

    // Pricing Section
    pricing: {
      title: "Prezzi Equi per",
      titleHighlight: "Ogni Esigenza",
      subtitle: "Scegli il piano adatto a te - trasparente e senza costi nascosti",
      loading: "Caricamento piani...",
      noPlans: "Nessun piano disponibile al momento",
      perMonth: "/mese",
      perYear: "/anno",
      oneTime: "una tantum",
      sessions: "Diagnosi/mese",
      popular: "POPOLARE",
      cta: "Scegli Piano",
      ctaFree: "Inizia Gratis"
    },

    // FAQ Section
    faq: {
      title: "Domande",
      titleHighlight: "Frequenti",
      subtitle: "Risposte alle domande più importanti su CarCortex-AI",
      items: [
        {
          question: "Quanto sono accurate le diagnosi IA?",
          answer: "Il nostro sistema Dual-AI (Gemini 2.5 Pro + GPT-4o) raggiunge una precisione del 99.5%. Le due IA si validano a vicenda e utilizzano dati attuali da milioni di casi di riparazione. In caso di incertezza, raccomandano un controllo in officina."
        },
        {
          question: "Carcortex-ai sostituisce uno strumento diagnostico professionale?",
          answer: "Carcortex-ai è un supplemento, non un sostituto. Interpreta sintomi, suggerisce passaggi di test e valuta misurazioni. Per i codici errore OBD serve ancora uno strumento diagnostico. Tuttavia, molti problemi possono essere diagnosticati senza hardware costoso."
        },
        {
          question: "Funziona per tutte le marche di veicoli?",
          answer: "Sì! Carcortex-ai supporta oltre 50 marche e più di 10.000 modelli. Dalle auto d'epoca ai veicoli elettrici attuali. L'IA adatta la diagnosi al tuo veicolo specifico."
        },
        {
          question: "Posso usare le diagnosi per le fatture clienti?",
          answer: "Assolutamente! I report PDF contengono tempo per ogni passaggio, test eseguiti e risultati. Perfetti per fatture clienti trasparenti e documentazione secondo gli standard officina."
        },
        {
          question: "Cosa succede con diagnosi errate?",
          answer: "In caso di incertezza, l'IA avvisa esplicitamente e raccomanda un controllo esperto. Se dovesse verificarsi una diagnosi errata, il sistema impara da essa. Puoi valutare ogni diagnosi e ricevi supporto gratuito per i problemi."
        },
        {
          question: "Quanto velocemente si ripaga l'investimento?",
          answer: "Per officine: ROI entro 2-4 settimane grazie al risparmio di tempo. Per hobbisti: Già con la prima visita in officina evitata (circa €80-150 risparmiati). Per flotte: 3-6 mesi attraverso costi di manutenzione ottimizzati."
        },
        {
          question: "Serve conoscenza tecnica?",
          answer: "No! Le istruzioni sono comprensibili per i non esperti. Guidano passo-passo attraverso la diagnosi con immagini, liste strumenti e note di sicurezza. Gli utenti avanzati ricevono dettagli tecnici aggiuntivi."
        },
        {
          question: "Come funziona la valutazione dei valori?",
          answer: "Misuri un valore (es. 11.8V tensione batteria) e lo inserisci con l'unità. L'IA confronta con i valori target specifici del veicolo (12.6-12.8V) e spiega se il valore è OK o cosa significa la deviazione."
        }
      ]
    },

    // CTA Section
    cta: {
      title: "Pronto per la Diagnostica Intelligente?",
      subtitle: "Inizia oggi e risparmia tempo e denaro",
      button: "Inizia Gratis Ora",
      buttonSecondary: "Guarda Demo"
    },

    // Footer
    footer: {
      description: "La piattaforma leader per la diagnostica veicoli con IA. Professionale, affidabile, conveniente.",
      product: "Prodotto",
      company: "Azienda",
      legal: "Legale",
      links: {
        features: "Funzionalità",
        pricing: "Prezzi",
        api: "API",
        changelog: "Changelog",
        about: "Chi Siamo",
        blog: "Blog",
        careers: "Carriere",
        contact: "Contatti",
        privacy: "Privacy",
        terms: "Termini",
        imprint: "Imprint",
        cookies: "Cookie"
      },
      copyright: "Tutti i diritti riservati",
      newsletter: {
        title: "Newsletter",
        subtitle: "Resta informato sugli aggiornamenti",
        placeholder: "La tua email",
        button: "Iscriviti"
      }
    }
  },

  fr: {
    // Navigation
    nav: {
      features: "Fonctionnalités",
      pricing: "Tarifs",
      faq: "FAQ",
      login: "Connexion",
      signup: "Inscription",
      demo: "Démo"
    },

    // Hero Section
    hero: {
      badge: "Powered by Gemini 2.5 Pro + GPT-4o",
      titleLine1: "Diagnostic Véhicule",
      titleLine2: "par Intelligence",
      titleLine3: "Artificielle",
      subtitle: "Diagnostics professionnels sans équipement coûteux. Deux systèmes IA se valident mutuellement pour",
      subtitleAccent1: " une précision maximale",
      subtitleAnd: " et",
      subtitleAccent2: " des guides détaillés",
      subtitleEnd: ". Économisez jusqu'à",
      subtitleSavings: " 87% des coûts",
      subtitleVs: " par rapport aux ateliers.",
      ctaPrimary: "Essai Gratuit",
      ctaSecondary: "Commencer"
    },

    // Stats
    stats: {
      activeUsers: "Utilisateurs Actifs",
      diagnoses: "Diagnostics Réalisés",
      rating: "Note Moyenne",
      savings: "Économies"
    },

    // Trust Badges
    trustBadges: {
      ssl: "Chiffrement SSL",
      gdpr: "Conforme RGPD",
      support: "Support 24/7",
      quality: "Qualité Certifiée"
    },

    // Use Cases Section
    useCases: {
      title: "Parfait pour",
      titleHighlight: "Chaque Usage",
      subtitle: "Que vous soyez un atelier professionnel, un amateur ou gestionnaire de flotte - Carcortex-ai fait gagner temps et argent",
      workshop: {
        title: "Atelier Professionnel",
        description: "Réduisez le temps de diagnostic de 80% et augmentez votre productivité",
        benefits: [
          "Jusqu'à 5 diagnostics supplémentaires par jour",
          "Rapports professionnels pour les clients",
          "Moins de diagnostics erronés",
          "Approbations de réparation plus rapides"
        ],
        roi: "ROI en < 1 mois"
      },
      hobby: {
        title: "Mécanicien Amateur",
        description: "Économisez les coûteux frais d'atelier et réparez vous-même",
        benefits: [
          "Plus de visites coûteuses à l'atelier",
          "Instructions détaillées",
          "Économisez sur l'auto-réparation",
          "Apprenez à connaître votre véhicule"
        ],
        roi: "Économies dès la première utilisation"
      },
      fleet: {
        title: "Gestion de Flotte",
        description: "Optimisez les coûts de maintenance pour toute votre flotte",
        benefits: [
          "Gestion centralisée des véhicules",
          "Maintenance Prédictive",
          "Optimisation des coûts",
          "Documentation conformité"
        ],
        roi: "20-30% d'économies"
      }
    },

    // Features Section
    features: {
      title: "Technologie IA",
      titleHighlight: "de Pointe",
      subtitle: "Deux systèmes IA leaders travaillent ensemble pour des diagnostics précis et fiables",
      items: {
        dualAi: {
          title: "Système Dual-IA",
          description: "Gemini 2.5 Pro + GPT-4o se valident mutuellement pour une précision et fiabilité maximales",
          benefit: "99.5% Précision"
        },
        assessment: {
          title: "Évaluation Intelligente",
          description: "Mesurez tension, résistance ou pression - l'IA compare avec les valeurs cibles et explique les écarts",
          benefit: "Pas de Mauvaise Interprétation"
        },
        fast: {
          title: "Diagnostic Ultra-Rapide",
          description: "Du symptôme à la solution en moins de 60 secondes - fini les heures de recherche",
          benefit: "16x Plus Rapide"
        },
        webResearch: {
          title: "Recherche Web Live",
          description: "Accès aux bulletins techniques actuels, rappels et forums d'experts en temps réel",
          benefit: "Toujours à Jour"
        },
        pdfReports: {
          title: "Rapports PDF Professionnels",
          description: "Rapports détaillés avec temps par étape - parfaits pour les factures clients et la documentation",
          benefit: "Conforme Atelier"
        },
        stepByStep: {
          title: "Guide Étape par Étape",
          description: "Positions exactes, outils nécessaires, valeurs cibles et consignes de sécurité pour chaque étape",
          benefit: "Aussi pour Débutants"
        }
      }
    },

    // Parallax Section
    parallax: {
      title: "Diagnostic Professionnel",
      subtitle: "Comme à l'atelier - seulement plus rapide, moins cher et de n'importe où"
    },

    // OBD Section
    obd: {
      badge: "NOUVEAU: Diagnostic OBD Live",
      title: "Diagnostic à Distance avec",
      titleHighlight: "CarCortex OBD Agent",
      subtitle: "Le",
      subtitleHighlight: "CarCortex OBD Dongle",
      subtitleEnd: "révolutionne le diagnostic véhicule: Notre IA récupère toutes les données pertinentes",
      subtitleDirect: "directement du véhicule",
      subtitleFinal: "et crée un diagnostic live incroyablement précis – en temps réel, à distance, sans visite à l'atelier.",
      features: {
        desktopApp: "Application Desktop Windows",
        liveData: "Données Live",
        vgate: "Vgate OBD2",
        kmManipulation: "Manipulation KM"
      },
      howItWorks: "Comment ça Marche – en 4 Étapes",
      steps: [
        {
          title: "Commander CarCortex OBD Dongle",
          description: "Commandez le dongle CarCortex OBD2 Bluetooth spécialement configuré. Plug & Play, aucune configuration nécessaire."
        },
        {
          title: "Brancher au Véhicule",
          description: "Insérez le dongle dans le port OBD de votre véhicule (généralement sous le tableau de bord). Se connecte automatiquement via Bluetooth."
        },
        {
          title: "Installer Desktop Agent",
          description: "Téléchargez CarCortex OBD Agent pour Windows. Une fois installé, il détecte automatiquement le dongle."
        },
        {
          title: "Profitez du Diagnostic Live",
          description: "L'IA récupère TOUTES les données nécessaires directement du véhicule et crée un diagnostic live extrêmement précis – le GAME CHANGER!"
        }
      ],
      ctaPrimary: "En Savoir Plus & Précommander",
      ctaSecondary: "S'abonner Maintenant",
      inDevelopment: "EN DÉVELOPPEMENT - BIENTÔT DISPONIBLE",
      gamechangerNote: "Le GAME CHANGER: Premier diagnostic IA au monde avec accès live direct à toutes les données véhicule. CarCortex OBD dongle disponible chez nous à €49,90."
    },

    // Dongle Shop Section
    dongleShop: {
      comingSoon: "BIENTÔT DISPONIBLE - EN DÉVELOPPEMENT",
      title: "CarCortex",
      titleHighlight: "OBD Dongle",
      subtitle: "Le",
      subtitleHighlight: "CarCortex OBD Dongle Original",
      subtitleEnd: "pour l'expérience de diagnostic live ultime.",
      inDev: "Actuellement en développement",
      notifyText: "- inscrivez-vous pour être notifié en premier!",
      soonAvailable: "BIENTÔT DISPONIBLE",
      productName: "CarCortex OBD Pro Dongle",
      productFeatures: "Plug & Play • Bluetooth 5.0 • Tous Protocoles",
      features: {
        liveDiagnosis: "Diagnostic Live",
        allProtocols: "Tous Protocoles OBD",
        bluetooth: "Bluetooth 5.0",
        windows: "Compatible Windows"
      },
      notify: "Me Notifier",
      registerInfo: "Nous vous informerons dès que le dongle sera disponible"
    },

    // Comparison Section
    comparison: {
      title: "Atelier vs.",
      titleHighlight: "CarCortex-AI",
      subtitle: "Voyez par vous-même combien vous pouvez économiser",
      headers: {
        feature: "Caractéristique",
        workshop: "Atelier",
        carcortex: "CarCortex-AI",
        savings: "Économies"
      },
      items: [
        {
          feature: "Coût Diagnostic",
          workshop: "80-150€ par diagnostic",
          carcortex: "À partir de 1€ par diagnostic",
          savings: "99% moins cher"
        },
        {
          feature: "Temps d'Attente",
          workshop: "1-3 jours rendez-vous",
          carcortex: "Disponible 24/7",
          savings: "Pas d'attente"
        },
        {
          feature: "Durée Diagnostic",
          workshop: "2-4 heures",
          carcortex: "< 5 minutes",
          savings: "48x plus rapide"
        },
        {
          feature: "Niveau de Détail",
          workshop: "Codes erreur basiques",
          carcortex: "Étape par étape avec valeurs cibles",
          savings: "10x plus détaillé"
        },
        {
          feature: "Transparence",
          workshop: "Diagnostic boîte noire",
          carcortex: "Vue complète & explication",
          savings: "100% transparent"
        }
      ]
    },

    // Testimonials
    testimonials: {
      title: "Ce que Disent nos",
      titleHighlight: "Clients",
      subtitle: "Des milliers d'utilisateurs satisfaits font confiance à CarCortex-AI",
      items: [
        {
          name: "Michael Weber",
          role: "Mécanicien Certifié, Weber Auto",
          content: "Nous avons réduit notre temps de diagnostic de 75%! Le système Dual-IA trouve des erreurs que même notre outil de diagnostic professionnel avait manquées. ROI atteint en 2 semaines.",
          metric: "5 commandes supplémentaires/jour"
        },
        {
          name: "Sarah Müller",
          role: "Responsable Atelier, AutoService Müller",
          content: "Les rapports PDF avec suivi du temps valent de l'or! Nos clients apprécient la transparence et nous pouvons calculer plus précisément. Plus de vagues 'vérifier capteur'.",
          metric: "40% satisfaction client en plus"
        },
        {
          name: "Thomas Schmidt",
          role: "Mécanicien Amateur & Passionné BMW",
          content: "J'ai déjà économisé plus de 2000€ en frais d'atelier! Les instructions sont si précises que je peux effectuer des réparations complexes moi-même. Recommandation absolue!",
          metric: "2400€ économisés en 6 mois"
        },
        {
          name: "Frank Becker",
          role: "Gestionnaire de Flotte, LogiTrans AG",
          content: "Pour notre flotte de 50 véhicules, Carcortex-ai est un game-changer. La maintenance prédictive réduit nos temps d'arrêt de 60%. L'investissement a été rentabilisé en 3 mois.",
          metric: "60% moins de temps d'arrêt"
        }
      ]
    },

    // Pricing Section
    pricing: {
      title: "Tarifs Équitables pour",
      titleHighlight: "Chaque Besoin",
      subtitle: "Choisissez le plan qui vous convient - transparent et sans frais cachés",
      loading: "Chargement des plans...",
      noPlans: "Aucun plan disponible actuellement",
      perMonth: "/mois",
      perYear: "/an",
      oneTime: "unique",
      sessions: "Diagnostics/mois",
      popular: "POPULAIRE",
      cta: "Choisir Plan",
      ctaFree: "Commencer Gratuit"
    },

    // FAQ Section
    faq: {
      title: "Questions",
      titleHighlight: "Fréquentes",
      subtitle: "Réponses aux questions les plus importantes sur CarCortex-AI",
      items: [
        {
          question: "Quelle est la précision des diagnostics IA?",
          answer: "Notre système Dual-IA (Gemini 2.5 Pro + GPT-4o) atteint une précision de 99.5%. Les deux IA se valident mutuellement et utilisent des données actuelles de millions de cas de réparation. En cas d'incertitude, ils recommandent une inspection en atelier."
        },
        {
          question: "Carcortex-ai remplace-t-il un outil de diagnostic professionnel?",
          answer: "Carcortex-ai est un complément, pas un remplacement. Il interprète les symptômes, suggère des étapes de test et évalue les mesures. Pour les codes erreur OBD, vous avez toujours besoin d'un outil de diagnostic. Cependant, de nombreux problèmes peuvent être diagnostiqués sans matériel coûteux."
        },
        {
          question: "Fonctionne-t-il pour toutes les marques de véhicules?",
          answer: "Oui! Carcortex-ai prend en charge plus de 50 marques et plus de 10 000 modèles. Des voitures classiques aux véhicules électriques actuels. L'IA adapte son diagnostic à votre véhicule spécifique."
        },
        {
          question: "Puis-je utiliser les diagnostics pour les factures clients?",
          answer: "Absolument! Les rapports PDF contiennent le temps par étape, les tests effectués et les résultats. Parfaits pour des factures clients transparentes et une documentation conforme aux standards atelier."
        },
        {
          question: "Que se passe-t-il en cas de diagnostic erroné?",
          answer: "En cas d'incertitude, l'IA avertit explicitement et recommande une inspection experte. Si un diagnostic erroné survient, le système en tire des leçons. Vous pouvez noter chaque diagnostic et recevoir un support gratuit pour les problèmes."
        },
        {
          question: "À quelle vitesse l'investissement est-il rentabilisé?",
          answer: "Pour les ateliers: ROI en 2-4 semaines grâce aux économies de temps. Pour les amateurs: Dès la première visite à l'atelier évitée (environ 80-150€ économisés). Pour les flottes: 3-6 mois grâce aux coûts de maintenance optimisés."
        },
        {
          question: "Ai-je besoin de connaissances techniques?",
          answer: "Non! Les instructions sont compréhensibles pour les non-experts. Elles guident étape par étape à travers le diagnostic avec images, listes d'outils et consignes de sécurité. Les utilisateurs avancés reçoivent des détails techniques supplémentaires."
        },
        {
          question: "Comment fonctionne l'évaluation des valeurs?",
          answer: "Vous mesurez une valeur (ex: 11.8V tension batterie) et l'entrez avec l'unité. L'IA compare avec les valeurs cibles spécifiques au véhicule (12.6-12.8V) et explique si la valeur est OK ou ce que signifie l'écart."
        }
      ]
    },

    // CTA Section
    cta: {
      title: "Prêt pour le Diagnostic Intelligent?",
      subtitle: "Commencez aujourd'hui et économisez temps et argent",
      button: "Commencer Gratuit",
      buttonSecondary: "Voir Démo"
    },

    // Footer
    footer: {
      description: "La plateforme leader pour le diagnostic véhicule par IA. Professionnel, fiable, abordable.",
      product: "Produit",
      company: "Entreprise",
      legal: "Mentions Légales",
      links: {
        features: "Fonctionnalités",
        pricing: "Tarifs",
        api: "API",
        changelog: "Changelog",
        about: "À Propos",
        blog: "Blog",
        careers: "Carrières",
        contact: "Contact",
        privacy: "Confidentialité",
        terms: "CGU",
        imprint: "Mentions",
        cookies: "Cookies"
      },
      copyright: "Tous droits réservés",
      newsletter: {
        title: "Newsletter",
        subtitle: "Restez informé des mises à jour",
        placeholder: "Votre email",
        button: "S'inscrire"
      }
    }
  }
};

// Helper function to get landing translations
export const getLandingTranslations = (locale) => {
  return landingTranslations[locale] || landingTranslations.de;
};
